import { CommonModule, DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { RouterLink } from "@angular/router";
import { KeyboardArrowLeftComponent } from "@src/app/components/svg/keyboard-arrow-left/keyboard-arrow-left.component";
import { KeyboardArrowRightComponent } from "@src/app/components/svg/keyboard-arrow-right/keyboard-arrow-right.component";
import { Subcanal } from "@src/app/models/interfaces/canal.interface";
import { PortadaService } from "@src/app/servicios/portada/portada.service";
import { firstValueFrom } from "rxjs";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";

@Component({
  selector: "app-secondary-menu",
  templateUrl: "./secondary-menu.component.html",
  styleUrls: ["./secondary-menu.component.scss"],
  imports: [RouterLink, KebabCasePipe, CommonModule, KeyboardArrowLeftComponent, KeyboardArrowRightComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondaryMenuComponent implements OnInit {
  subcanales: Subcanal[] = [];
  bloque_activo: boolean = false;
  configBloque: any;
  shouldShowArrows: boolean = false;
  showArrows: boolean = false;
  private _resizable: boolean;

  @Input() configPrensa: any;
  @Input() set resizable(value: boolean) {
    this._resizable = value ?? false;
  }
  @ViewChild("secondary") sliderRef: ElementRef;

  get resizable(): boolean {
    return this._resizable;
  }

  constructor(
    private readonly portadaService: PortadaService,
    private readonly elementRef: ElementRef,
    private readonly platformService: PlatformService,
    private readonly cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  ngOnInit(): void {
    if (!this.configPrensa) return;
    const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    this.configBloque = this.configPrensa.general[selectorName];
    this.bloque_activo = this.configBloque.bloque_activo === "true";
    if (this.bloque_activo) {
      firstValueFrom(this.portadaService.getCanal()).then((canales) => {
        this.subcanales = canales[0].subcanales?.filter((subcanal) => subcanal.activoPrensaFooter == "1") ?? [];
        this.cd.detectChanges();
      });
    }
  }

  ngAfterViewChecked() {
    if (this.platformService.isBrowser()) this.checkOverflow();
  }

  private checkOverflow() {
    const element = this.document.querySelector(".menu-secundario");
    const { scrollWidth, clientWidth } = element;
    this.shouldShowArrows = scrollWidth > clientWidth;

    if (this.shouldShowArrows) this.showArrows = true;
    else this.showArrows = false;
  }

  scroll(direction: string) {
    this.sliderRef.nativeElement.scrollBy({ left: direction === "left" ? -100 : 100, behavior: "smooth" });
  }

  trackByItem(item: any) {
    return item.id;
  }
}
